import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

/**
 * Build a download URL for file endpoints (XLSX/PDF).
 * Appends ?token=... so the browser <a href> can authenticate without headers.
 */
export const downloadUrl = (path) => {
  const token = localStorage.getItem("ytn_token");
  const sep = path.includes("?") ? "&" : "?";
  return `${API}${path}${sep}token=${encodeURIComponent(token || "")}`;
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ytn_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("ytn_token");
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
